<template>
  <div class="merchant-wrapper">
    <ArticleList :articles="list" />
  </div>
</template>

<script>
  import Pagination from '@/components/pagination.vue';
  import Empty from '@/pages/common/empty.vue';
  import ArticleList from '@/pages/article/_list.vue';
  import localstorage from '@/assets/utils/localstorage';
  import axios from 'axios'
  import { lists as articleList } from '@/api/article';
  import {
    mapState
  } from 'vuex';
  export default {
    components: {
      Pagination,
      Empty,
      ArticleList,
    },
    props: {
      isShowPagination: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        user_id: 0,
        list: []
      };
    },
    computed: {
      // ...mapState(['pageloading']),
    },
    watch: {},
    mounted() {
        // this.getList()
    },
    methods: {
        async getList(mold_id) {
          const postData = {
            page: 1,
            page_size: 4,
            search: '',
            type: 2,
            mold_id,
          }
          const articleData = await articleList(postData);
          this.list = articleData.data.list
        }

      }
  };
</script>
<style lang="scss">
.merchant-wrapper {
}
</style>
